module.exports = __webpack_public_path__ + "static/img/titleimage.382296ac.png";